const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export default function HeatmapGrid({ data }) {
  const matrix = Array.from({ length: 7 }, () => Array(24).fill(0));
  let max = 0;
  data.forEach(({ dayOfWeek, hour, count }) => {
    if (matrix[dayOfWeek] && hour >= 0 && hour < 24) {
      matrix[dayOfWeek][hour] = count;
      if (count > max) max = count;
    }
  });

  return (
    <div className="overflow-x-auto">
      <table className="border-collapse text-xs">
        <thead>
          <tr>
            <th className="sticky left-0 bg-white"></th>
            {Array.from({ length: 24 }, (_, h) => (
              <th key={h} className="font-normal text-gray-500 px-1">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {DAYS.map((day, d) => (
            <tr key={day}>
              <td className="sticky left-0 bg-white pr-2 text-right font-medium text-gray-700">{day}</td>
              {matrix[d].map((count, h) => {
                const intensity = max === 0 ? 0 : count / max;
                const bg = intensity === 0 ? '#F3F4F6' : `rgba(26, 110, 255, ${0.15 + intensity * 0.85})`;
                return (
                  <td
                    key={h}
                    title={`${day} ${h}:00 — ${count}`}
                    style={{ background: bg, width: 22, height: 22 }}
                    className="border border-white"
                  />
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
